import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { Chart } from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import Loader from "../../../components/ui/Loader/Loader";
import { IAM_API_BASE_URL_3 } from '../../../services/TapApiUrls';
import DateService from "../../../services/DateService";

const ProjectWidget = (props) => {
    
    const widgetUrl             =   IAM_API_BASE_URL_3 + '/group/project_status_widget_data';
    const updateMyDashboardRef  =   useRef();
    const access_token          =   useSelector(state => state.auth.access_token);
    const iam_user_sites        =   useSelector(state => state.app.user_sites || []);
    const widget_keys           =   useSelector(state => state.app.user_info?.widget_keys || []);

    const [widgetData, setWidgetData]   =   useState(null) 
    const [formData, setFormData]   =   useState({
        allSites        :   [],
        filterData      :   {
            canChange           :   false,
            search_site_id      :   "",
        }
    })

    const [projectData, setProjectData] = useState({
        loading         :   false,
        data            :   [],
        status          :   [],
        remark_time     :   '',
    });
    const [reload, setReload] = useState(false);


    useEffect(() => {
        setProjectData(pre => ({...pre, loading: true}));
        initializeFormFilter();
        if (reload) {
            projectWidgetData();
        } else if (formData.filterData.canChange) {
            projectWidgetData();
        } else {
            if (localStorage.getItem('projectWidget')) {

                let projectData = JSON.parse(localStorage.getItem('projectWidget'));
                if (projectData) {

                    let differenceInSeconds = DateService.differenceInSeconds(moment(projectData.time, 'DD-MM-YYYY HH:mm A').format());
                    if (differenceInSeconds > 86400) {
                        localStorage.removeItem('projectWidget')
                        setTimeout(() => {
                            projectWidgetData();
                        }, 1000 * (props.indexProps || 12));

                    } else {
                        setProjectData(pre => ({
                            ...pre,
                            data: projectData.data,
                            status :projectData.status,
                            loading:false,
                            remark_time: projectData.time,
                        }))
                    }
                } else {
                    setTimeout(() => {
                        projectWidgetData();
                    }, 1000 * (props.indexProps || 12));
                }
            } else {
                setTimeout(() => {
                    projectWidgetData();
                }, 1000 * (props.indexProps || 12));
            }
        }     

        let params          =   {};
        if(formData.filterData.search_site_id) {
            params          =   {...params, search_site_id : formData.filterData.search_site_id};
        }
       

    }, [formData.filterData, reload]);

    const initializeFormFilter = () => {
       setFormData(pre => ({
            ...pre,
            allSites : iam_user_sites.map(w => ({value: w.id, label: `${w.site_name} (${w.site_name})`})) 
        }))
        setWidgetData(widget_keys.length > 0 && widget_keys.find(st => {return("project_widget" == st.key)}) ? widget_keys.find(st => {return(st.key == "project_widget")})  : null)
    };

    const projectWidgetData =   ()  =>  {
        setProjectData(pre => ({...pre, loading: true}));
        
        let params          =   {...formData.filterData, reload : reload ? 'reload' : false};
        HttpAPICall.withAthorization('GET', widgetUrl, access_token, params, {} , (response) => {
            const res = response.data;
            console.log(res);
            
            setProjectData(pre => ({
                ...pre, 
                data    :   res.data,
                status : res.status,
                remark_time :   res.time
            }));
            if(!formData.filterData.search_site_id ){
                localStorage.setItem('projectWidget',JSON.stringify(res));
            }
            if(reload !== false){
                localStorage.setItem('projectWidget',JSON.stringify(res));
            }
        }).then(() => {
            setProjectData(pre => ({...pre, loading: false}))
            setReload(false)
            setFormData(pre => ({...pre, canChange : false}))
        });
    }

    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, { key: "project_widget", name: "Project Widget" });
    };
        const handleCountClick = (category, statusItem) => {
        const params = new URLSearchParams();
        const isWithoutCategory = !category.category_id || category.category_id === '' || category.category_name === 'Without Category';

        if (isWithoutCategory) {
            params.append('search_without_category', 'Y');
        } else if (category.category_id) {
            params.append('search_category_ids', category.category_id);
        }

        if(formData.filterData.search_site_id){
            params.append('search_site_ids', formData.filterData.search_site_id);

        }
         if (statusItem.status) {
            params.append('search_status', statusItem.key);
        }

        params.append('openSearch', '1');

        window.open(`/project?${params.toString()}`, '_blank');
    };

    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">Project Widget</h6>
                    </div> 
                    <div className="col-3">
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.allSites}
                            changeEvent={(selectedOption) => {
                                setFormData(pre => ({
                                    ...pre, 
                                    filterData : {
                                        ...formData.filterData,
                                        canChange : true,
                                        search_site_id : selectedOption ? selectedOption.value : ""
                                    }
                                }))
                            }}
                            value={formData.allSites.find(u => u.value == formData.filterData.search_site_id)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All Sites"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>Refresh</li>
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>{!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}</li>
                        </ul>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12">
                        <table className="table table-hover table-bordered table-borderless bg-white">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th className="text-start">Category</th>
                                    {projectData.status.map((statusItem) => (
                                        <th key={statusItem.key} style={{ width: "20%" }}>
                                            {statusItem.status}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {projectData.loading
                                    ? <tr>
                                        <td className="text-center" colSpan="5">
                                            <Loader />
                                        </td>
                                    </tr>
                                    :

                                    projectData.data.length > 0
                                        ? projectData.data.map((category) => (
                                            <tr key={category.category_id || category.category_name}>
                                                <td>{category.category_name}</td>
                                                {projectData.status.map((statusItem, i) => (
                                                    <td style={{ cursor: "pointer" }} onClick={() => handleCountClick(category, statusItem)} key={i}
                                                        className="text-end text-primary">
                                                        {category[statusItem.key] && category[statusItem.key] !== ""
                                                            ? category[statusItem.key]
                                                            : "0"}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                        : <tr>
                                            <td className="text-center" colSpan="5">
                                                No Record Found
                                            </td>
                                        </tr>
                                }
                            </tbody>
                            {!projectData.loading && projectData.data && projectData.data.length > 0 &&
                                <tfoot>
                                    <tr className="fw-bold">
                                        <td>Total</td>
                                        {projectData.status.map((statusItem) => {
                                            const total = projectData.data.reduce((sum, category) => {
                                                const value = category[statusItem.key];
                                                return sum + (value && value !== "" ? parseInt(value) : 0);
                                            }, 0);
                                            return (
                                                <td key={`total-${statusItem.key}`} className="text-end">
                                                    {total}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </tfoot>}

                        </table>
                    </div>

                </div>
                <div className="col-sm-12 text-muted fs11">
                    Report as of {projectData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />
        </div>
    );
};

export default ProjectWidget;
